import { observer } from "mobx-react-lite";
import React, { useEffect, useState, useMemo } from "react";
import { Switch } from "antd";
import { connect, registerHandler } from "../../utils/socket";
import { Button } from "antd";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import { getOrganizationMappings } from "../../utils/api";
import Konami from "react-konami-code";
import { CloseOutlined } from "@ant-design/icons";
import UserCircle from "./UserCircle";
import UserDetail from "./UserDetail";
import { buildBoxes } from "../../utils/dashboard";

import "./CommanderDashboard.css";

function CommanderDashboard({
  store,
  dashboardStore,
  authStore,
  orgDashboardStore,
}) {
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [orgName, setOrgName] = useState("");

  const onExpandChange = (expanded) => {
    setExpanded(expanded);
  };
  const fetchDashboardData = async (orgId, orgName) => {
    //orgStats
    //org users
    if (!authStore.user) {
      return;
    }
    dashboardStore.setOrgId(orgId);

    if (authStore.userRole !== "org_user") {
      const users = await getOrganizationMappings(orgId);

      dashboardStore.setUsers(users);
      dashboardStore.setOrgName(orgName);
    } else {
      dashboardStore.setUsers([
        { id: authStore.user["id"], user_id: authStore.user["user_code"] },
      ]);
    }
  };

  const socketMessageReceived = (data) => {
    const userCode = data.user_code;
    if (data.hasOwnProperty("heartRates")) {
      const heartrate = data["heartRates"][0];

      orgDashboardStore.setHeartRate(userCode, {
        "value": heartrate.heartRate,
        "timestamp": heartrate.timestamp
      });
    }

    // if (data.hasOwnProperty("motion")) {
    //   const motion = data["motion"];
    //   orgDashboardStore.setMotion(userCode, motion);
    // }

    if (
      data.hasOwnProperty("metrics")
    ) {
      if (data["metrics"] && data["metrics"].length > 0) {
        const status = data["metrics"][data["metrics"].length - 1];
        const sdnn = status["sdnn"];
        const timestamp  = status['timepoint'];

      orgDashboardStore.setHrv(userCode, {
        "value": sdnn,
        "timestamp": timestamp,
      });
       const color = status["color"];
        orgDashboardStore.setStatus(userCode, color);
        //orgDashboardStore.setAlertLabel(userCode, label);
      }
    }
  };
  useEffect(() => {
    connect();
    registerHandler(socketMessageReceived);
  }, []);

  useEffect(() => {

    if (!authStore || !authStore.user) {
      return;
    }
    console.log("reloading");
    setLoading(false);
    const orgId = dashboardStore.orgId ? dashboardStore.orgId : authStore.user.organization_details.id;
    const orgName = dashboardStore.orgName ? dashboardStore.orgName : authStore.user.organization_details.name;
    dashboardStore.setOrgId(orgId);
    setOrgName(orgName);
    fetchDashboardData(orgId, orgName);
  }, [authStore.user, dashboardStore.orgId, dashboardStore.orgName]);

  const users = useMemo(() => {
    return dashboardStore.users.map((x) => {
      return {
        userCode: x.user_id,
        color: orgDashboardStore.status[x.user_id] || "inactive",
        pinned: orgDashboardStore.pinned[x.user_id] || false,
        expanded: expanded,
      };
    });
  }, [
    dashboardStore.users,
    expanded,
    orgDashboardStore.pinned,
    orgDashboardStore.counter,
  ]);

  const boxes = useMemo(() => {
    return buildBoxes(users, orgDashboardStore);
  }, [users, orgDashboardStore.counter]);

  useEffect(() => {
    setLoading(false);
  }, []);

  const profileSelected = (userCode) => {
    setSelectedUser(userCode);
    setDrawerOpen(true);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const enableKonami = () => {
    orgDashboardStore.setAdminMode(true);
  };
  return (
    <>
      <div className="CommanderDashboard">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <React.Fragment>
            <div className={`side-drawer ${drawerOpen ? "open" : ""}`}>
              <Button
                className="Slider__close"
                type="text"
                onClick={toggleDrawer}
              >
                <CloseOutlined />
              </Button>
              {selectedUser && (
                <UserDetail
                  userCode={selectedUser}
                  dashboardStore={dashboardStore}
                  orgDashboardStore={orgDashboardStore}
                  orgId={dashboardStore.orgId}
                ></UserDetail>
              )}
            </div>
            <div
              className={`CommanderDashboard__outer_container ${
                drawerOpen ? "open" : ""
              }`}
            >
              <div>
                <div className="CommanderDashboard__expand">
                  Expanded{" "}
                  <Switch defaultChecked={expanded} onChange={onExpandChange} />
                </div>
                <h1>{orgName}</h1>
              </div>
              <div className="clear"></div>

              <div
                className={`CommanderDashboard__container ${
                  drawerOpen ? "open" : ""
                }`}
              >
                {users.length > 0 &&
                  boxes.map((box) => {
                    return (
                      <div
                        key={box[0].userCode + "_container"}
                        className="CommanderDashboard__inner_container"
                      >
                        {box.map((user) => {
                          return (
                            <UserCircle
                              key={user.userCode}
                              dashboardStore={dashboardStore}
                              orgDashboardStore={orgDashboardStore}
                              userCode={user.userCode}
                              pinned={user.pinned}
                              orgId={dashboardStore.orgId}
                              profileSelected={profileSelected}
                              expanded={expanded}
                            ></UserCircle>
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      <Konami action={() => enableKonami()}> </Konami>
    </>
  );
}

export default observer(CommanderDashboard);
